import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect, useState } from 'react';
import { createQueryClient } from '@/lib/query/query-client';
import { subscribeAuthEvent } from '@/lib/auth/auth-events';

export function QueryProvider({ children }: { children: React.ReactNode }) {
  // Use centralized query client configuration
  const [queryClient] = useState(() => createQueryClient());

  useEffect(() => {
    const unsubscribe = subscribeAuthEvent('session-cleared', () => {
      queryClient.clear();
    });

    return () => unsubscribe();
  }, [queryClient]);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
